<script setup>
import TableBody from '@/components/shared/table/TableBody.vue'

//Emits and props
defineProps({
  caption: {
    type: String,
    default: '',
  },
})
</script>

<template>
  <TableBody v-bind="$attrs">
    <caption
      v-if="caption"
      sr-only
    >
      {{ caption }}
    </caption>
    <thead v-if="$slots.headerRow">
      <slot name="head" />
    </thead>
    <tbody>
      <slot />
    </tbody>
  </TableBody>
</template>

<style module lang="scss">
.icon {
  flex: 0 0 2.5rem;
  min-width: 2.5rem;
  display: flex;
  justify-content: center;
}
</style>
